module.exports = __webpack_public_path__ + "static/media/WF.94563428.svg";